// customizedCity: [],
//         searchCharts: [], // suggestion的排序显示规则
//         isExactSearch: false,
//         propertyConfigs: []
export const SET_CUSTOMIZED_CITY = 'SET_CUSTOMIZED_CITY';
export const SET_SEARCH_CHARTS = 'SET_SEARCH_CHARTS';
export const SET_IS_EXACT_SEARCH = 'SET_IS_EXACT_SEARCH';
export const SET_PROPERTY_CONFIGS = 'SET_PROPERTY_CONFIGS';
export const SET_SEARCH_DATA = 'SET_SEARCH_DATA'; // 中台
export const SET_SHOW_LOCATION = 'SET_SHOW_LOCATION'; // 中台
export const SET_LOCATION_SUGGESTION_URL = 'SET_LOCATION_SUGGESTION_URL';
export const SET_KEYWORD = 'SET_KEYWORD';
export const SET_KEYWORD_TYPE = 'SET_KEYWORD_TYPE';
